import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'PayResponseService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$stateParams'
];

class PayResponseController{
  constructor ($scope, PayResponseService, $state, $rootScope, SharedService, $uibModal, $stateParams) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.$stateParams = $stateParams;
    this.PayResponseService = PayResponseService;
    this.SharedService = SharedService;
    this.loanding = false;
    this.payInfo = {};
  }

  $onInit(){
    this.getResponse();
  }
  
  getResponse() {
    this.PayResponseService.getResponse(this.$stateParams.idPay).then(({data}) => {
      this.payInfo = data;
    }).catch(reason => {
    
    })
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

PayResponseController.$inject = inject;

export default PayResponseController;




/** WEBPACK FOOTER **
 ** ./www/components/pay-zone/response/response.controller.js
 **/